/**
 * element plus
 *
 * @author Shigq
 * @date 2021/11/10 10:45
 */
require('element-plus/theme-chalk/index.css')
require('../assets/scss/index.scss')

var { ref } = require('vue')
var ElementPlus = require('element-plus')
var icons = require('@element-plus/icons-vue')
var { useI18n } = require('./i18n')
var { utils: { commonUtils } } = require('@libs/dep-private')

/* todo - constant */
var SPECIAL_VERSION = '1.0.2-beta.59'

/* todo - methods */
/**
 * set private properties
 */
function setPrivateProperties() {
	/**
	 * use lang
	 *
	 * @description 解决ElementPlus-1.0.2-beta.59及之后，不显示中文bug
	 * @param app
	 * @param ref
	 * @param locale
	 */
	ElementPlus.useLang = (app, ref, locale) => {
		var template = (str, option) => {
			if (!str || !option) return str
			return str.replace(/\{(\w+)\}/g, (_, key) => {
				return option[key]
			})
		}

		// 注入全局属性,子组件都能通过inject获取
		app.provide('ElLocaleInjection', {
			lang: ref(locale.name),
			locale: ref(locale),
			t: (...args) => {
				var [path, option] = args
				var value
				var array = path.split('.')
				var current = locale
				for (let i = 0, j = array.length; i < j; i++) {
					var property = array[i]
					value = current[property]
					if (i === j - 1) return template(value, option)
					if (!value) return ''
					current = value
				}
			},
		})
	}
}

/**
 * get current instance
 *
 * @returns {any}
 */
function getCurrentInstance() {
	return ElementPlus
}

/**
 * install
 *
 * @param app
 */
function install(app, config) {
	var { t, messages, locale } = useI18n()

	var currentVersion = commonUtils.getDigitalFromStr(ElementPlus.version)
	var specialVersion = commonUtils.getDigitalFromStr(SPECIAL_VERSION)

	if (currentVersion < specialVersion) {
		app.use(ElementPlus, { i18n: t })
	} else {
		setPrivateProperties()

		ElementPlus.useLang(app, ref, messages[locale])

		app.use(ElementPlus)
	}

	if (config && config.icons) {

		config.icons.forEach(key => {
			app.component(key, icons[key])
		})
	}
}

module.exports = {
	getCurrentInstance,
	install,
}
